// Getting around the machine's desktop (agent desktop_nav.go): its open windows, bringing one
// to the front or closing it, its installed apps and opening one. What the desktop pane's window bar and
// Apps launcher are drawn from (ui/DesktopDock.tsx).

import { conn } from './connection';
import type { DesktopWindow } from './protocol';

/** A window open on the desktop (its X id, "0x3a00007"; `icon` a data: URL when the app has one). */
export type { DesktopWindow };

/** An app installed on the machine; `id` is its .desktop file ("google-chrome.desktop"). */
export interface DesktopApp {
  id: string;
  name: string;
  icon?: string;
}

export const desktopWindows = () => conn.control<{ windows: DesktopWindow[] | null }>('desktop.windows').then((r) => r.windows ?? []);
export const focusWindow = (id: string) => conn.control('desktop.focus', { window: id });
/** Asks the window to close, as its own close button does: an app with unsaved work asks first. */
export const closeWindow = (id: string) => conn.control('desktop.close', { window: id });
export const desktopApps = () => conn.control<{ apps: DesktopApp[] | null }>('desktop.apps').then((r) => r.apps ?? []);
export const launchApp = (id: string) => conn.control('desktop.launch', { app: id });
